import React, { Component } from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import { Text, Row, FlexView, Col } from '@cuemath/comps';
import { HEADER_ICONS } from 'constants/chapter-block';

const BlockWrapper = styled(FlexView)`
  width: 780px;
  border-radius: 4px;
  background-color: ${COLORS.WHITE};
  box-shadow: 0 5px 15px 0 rgba(51, 79, 110, 0.1);
  display: flex;
  flex-direction: row;
  padding: 0 10px;
`;

const BlockHeader = styled(Row)`
  position: relative;
  flex-grow: 1;
  padding: 12px;
`;

const TitleRow = styled(Row)`
  padding-left: ${({ isGoal }) => (isGoal ? '24px' : '0')};
`;

const TitleImage = styled.img`
  width: 24px;
  height: 24px;
`;

const FullTextContainer = styled.div`
  position: relative;
`;

const FullText = styled(Text)`
  background-color: ${COLORS.WHITE};
  box-shadow: 2px 2px 5px 2px rgba(0, 56, 122, 0.15);
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  padding: 6px 12px;
  width: fit-content;
  top: calc(-100% - 12px);
  border-radius: 4px;
  display: none;
  z-index: 1;
  opacity: 0;
  transition: display 1s, opacity 1s ease-in-out;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    top: calc(-100% - 35px);
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    top: calc(-100% - 35px);
  }
  ${FullTextContainer}:hover & {
    display: block;
    opacity: 1;
  }
`;

const SheetText = styled(Text)`
  max-width: ${({ shouldReduceLength }) => (shouldReduceLength ? '340px' : '400px')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-decoration: ${({ dependency }) => (dependency ? 'underline' : 'none')};
  cursor: ${({ dependency }) => dependency && 'pointer'};
`;

const SpanText = styled(Text)`
  display: inline;
`;

class ExtraSheetBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nodeSheetSelected: false,
      selectedNodeListCopy: [],
    };

    this.optionsRef = React.createRef();
  }

  static getDerivedStateFromProps(
    { allNodesSelected, selectedNodeList, nodeId },
    { nodeSheetSelected, selectedNodeListCopy },
  ) {
    let newState = {};

    if (allNodesSelected) {
      newState.nodeSheetSelected = true;

      return newState;
    }
    if (
      !allNodesSelected &&
      nodeSheetSelected &&
      !JSON.stringify(selectedNodeListCopy).includes(nodeId) &&
      !JSON.stringify(selectedNodeList).includes(nodeId)
    ) {
      newState.nodeSheetSelected = false;

      return newState;
    }
    return null;
  }

  componentDidUpdate() {
    const { allNodesSelected, selectedNodeList } = this.props;
    if (
      !allNodesSelected &&
      selectedNodeList.length === 0 &&
      this.state.selectedNodeListCopy.length > 0
    ) {
      this.setState({
        selectedNodeListCopy: [],
      });
    }
  }

  render() {
    const headerIcon = HEADER_ICONS.DEFAULT;
    const { nodeSheetSelected } = this.state;
    const {
      learnosity_activity_ref,
      nodeId,
      nodeType,
      selectedNodeList,
      allNodesAreSelected,
    } = this.props;

    return (
      <FlexView>
        <BlockWrapper alignItems="center">
          <BlockHeader justifyContent="space-between">
            <TitleRow alignItems="center">
              <TitleImage src={headerIcon} alt="basic" />
              <Col>
                <FullTextContainer>
                  <FullText size="small" weight="semibold">
                    {`${nodeType} • ${learnosity_activity_ref}`}
                  </FullText>
                  <SheetText weight="semibold" size="medium" color={COLORS.COLA}>
                    {nodeType && (
                      <SpanText weight="bold" size="medium" color={COLORS.COLA}>
                        {nodeType}
                        {nodeType ? ' • ' : ''}
                      </SpanText>
                    )}
                    {learnosity_activity_ref}
                  </SheetText>
                </FullTextContainer>
              </Col>
            </TitleRow>
          </BlockHeader>
        </BlockWrapper>
      </FlexView>
    );
  }
}

export default ExtraSheetBlock;
